// Project versioning with semantic versioning
// Major.Minor.Patch
const MAJOR_VERSION = 1; // Increases with breaking changes
const MINOR_VERSION = 3; // Increases with new features
const PATCH_VERSION = 5; // Increases with bug fixes

// For feature-based commits, update these numbers manually:
// MAJOR: Breaking changes
// MINOR: New features
// PATCH: Bug fixes

// Returns a fixed version number
const getVersion = (): string => {
  // Fixed version format: Major.Minor.Patch
  return `${MAJOR_VERSION}.${MINOR_VERSION}.${PATCH_VERSION}`;
};

export default getVersion; 